import { createPinia, defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useScreensizeStore = defineStore('screensize-store', () => {
  const isMobile = ref(window.BREAKPOINTS.isMobile);
  const isTablet = ref(window.BREAKPOINTS.isTablet);
  const isTabletLarge = ref(window.BREAKPOINTS.isTabletLarge);
  const isDesktop = ref(window.BREAKPOINTS.isDesktop);

  const isMobileOrTablet = computed(() => isMobile.value || isTablet.value);

  const setBreakpoints = (breakpoints) => {
    isMobile.value = breakpoints.isMobile;
    isTablet.value = breakpoints.isTablet;
    isTabletLarge.value = breakpoints.isTabletLarge;
    isDesktop.value = breakpoints.isDesktop;
  };

  return {
    isMobile,
    isTablet,
    isTabletLarge,
    isDesktop,
    isMobileOrTablet,
    setBreakpoints,
  };
});

export const piniaScreensize = createPinia();
